import { createContext } from 'react';

const CoreTabsContext = createContext(null);

export default CoreTabsContext;
